 
import React from "react";

import "./../../../styles/FooterComponent.scss";
import LinkComponent from './LinkComponent';
import { useTranslation } from 'react-i18next';

// Footer component 
// Defines footer elements for the app
export default  function FooterComponent(props) {
    const { t } = useTranslation();
    return ( 
        <footer className="footer" style={props.loginPage ? {width: '100%'} : {'width':'calc(100% - 170px)', right: 0}}>
            <div className="footer-container">
                <div>
                    <p>{t('FOOTER')}</p>
                </div>
                <div>
                    <LinkComponent target="_blank" href="https://www.facebook.com/profile.php?id=100082943871215" text="Facebook" />
                    <LinkComponent target="_blank" href="https://www.instagram.com/reflective_research/" text="Instagram" />
                    <LinkComponent target="_blank" href="https://www.linkedin.com/in/reflective-research" text="Linkedin" />
                </div>
            </div>
        </footer>
    );
}
